<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用“|”作为条件分隔符</Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索"
                   @on-enter="searchinput"/>
            <slot name="new_btn">
              <Button type="primary" @click="editModal('', 'post', '新增')" class="search-btn">新增</Button>
            </slot>
            <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border
                 :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
              <FormItem
                label="标题"
                prop="Jname"
              >
                <Input
                  v-model="formValidate.Jname"
                  placeholder="请输入标题"
                ></Input>
              </FormItem>
              <FormItem
                label="开始时间"
                prop="Jstime"
              >
                <DatePicker type="date" editable v-model="formValidate.Jstime" format="yyyy-MM-dd"
                            placement="bottom-end" placeholder="请选择开始时间"></DatePicker>
              </FormItem>
              <FormItem
                label="结束时间"
                prop="Jotime"
              >
                <DatePicker type="date" editable v-model="formValidate.Jotime" format="yyyy-MM-dd"
                            placement="bottom-end" placeholder="请选择结束时间"></DatePicker>
              </FormItem>
              <FormItem
                label="状态参数"
                prop="Jstate"
              >
                <el-select
                  v-model="formValidate.Jstate"
                  filterable
                  default-first-option
                  placeholder="请选择状态">
                  <el-option
                    v-for="item in JstateList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="举办单位"
                prop="Creater"
              >
                <Input
                  v-model="formValidate.Creater"
                  placeholder="请输入举办单位"
                ></Input>
              </FormItem>
              <FormItem
                label="举办地址"
                prop="Jaddress"
              >
                <Input
                  v-model="formValidate.Jaddress"
                  placeholder="请输入举办地址"
                ></Input>
              </FormItem>
              <FormItem
                label="网址"
                prop="Jurl"
              >
                <Input
                  v-model="formValidate.Jurl"
                  placeholder="请输入网址"
                ></Input>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit('formValidate')"
                >提交
                </Button>
                <Button
                  @click="handleReset('formValidate')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>
            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>
  </div>
</template>
<script>

import {
  getJobfaironlinelist,
  operationJobfaironline,
} from '@/api/jobfair/jobfaironline.js'
import {getsysparameterList} from "@/api/system/sys_parameter";

let moment = require("moment");
export default {
  data() {
    return {
      spinShow: false,
      fullscreenLoading: false,
      JstateList: [],
      formValidate: {},
      searchVal: "",
      tableData: [],
      modalMap: {
        modalVisible: false,
        modalTitle: "新建"
      },
      tableSelectIdList: [],
      editModalData: "",
      pageNum: 1, // 当前页码
      pageTotal: 0, // 数据总数
      pageSize: 15, // 每页条数

      ruleValidate: {
        Jname: [
          {
            required: true,
            message: "标题不能为空",
            trigger: "blur"
          }
        ]
,        Jstime: [
          {
            required: true,
            type: "date",
            message: "请选择开始时间",
            trigger: "change"
          }
        ]
,        Jotime: [
          {
            required: true,
            type: "date",
            message: "请选择结束时间",
            trigger: "change"
          }
        ]
,        Jstate: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change"
          }
        ]
,        Creater: [
          {
            required: true,
            message: "举办单位不能为空",
            trigger: "blur"
          }
        ]
,        Jaddress: [
          {
            required: true,
            message: "举办地址不能为空",
            trigger: "blur"
          }
        ]
,        Jurl: [
          {
            required: true,
            message: "网址不能为空",
            trigger: "blur"
          }
        ]
      },
      columns: [
        {
          type: 'selection',
          key: 'Id',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: "标题",
          key: "Jname",
          align: "center",
          sortable: true        }
,        {
          title: "开始时间",
          key: "Jstime",
          align: "center",
          sortable: true        }
,        {
          title: "结束时间",
          key: "Jotime",
          align: "center",
          sortable: true        }
,        {
          title: "状态",
          key: "Jstate_CN",
          width: 120,
          align: "center",
          sortable: true        }
,        {
          title: "举办单位",
          key: "Creater",
          align: "center",
          sortable: true        }
,        {
          title: "举办地址",
          key: "Jaddress",
          align: "center",
          sortable: true        }
,        {
          title: "网址",
          key: "Jurl",
          align: "center",
          sortable: true        }
,        {
          title: "操作",
          key: "handle",
          fixed: "right",
          width: 180,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.editModal(params.row, "post", "修改");
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.delData(params);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
    };
  },
  methods: {
    getJobfaironlinelist(key, value) {
      this.spinShow = true
      getJobfaironlinelist(this.pageNum, this.pageSize, key, value).then(res => {
        if (res.data.code === 0) {
          this.pageTotal = res.data.count
          this.tableData = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },
    getParameterList() {
      getsysparameterList('jobfair_online', 'Jstate').then(res => {
        if (res.data.code === 0) {
          this.JstateList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    handleSelectChange(val) {
      let SelectIdList = []
      val.forEach(item => {
        SelectIdList.push(item.Id)
      })
      this.tableSelectIdList = SelectIdList
    },
    closeModal() {
      this.dialog.show = false
    },
    editModal(paramsRow, meth, mtitle) {
      this.modalMap.modalVisible = true;
      this.modalMap.modalTitle = mtitle;
      this.editModalData = meth;
      // this.getParameterList();
      var day2 = new Date();
      day2.setTime(day2.getTime());
      var s2 = day2.getFullYear() + "-" + (day2.getMonth() + 1) + "-" + day2.getDate() + " " + day2.getHours() + ":" + day2.getMinutes() + ":" + day2.getSeconds();
      if (paramsRow && paramsRow.Id) {
        this.formValidate = {
          Id: paramsRow.Id,
          Jname: paramsRow.Jname,
          Jstime: paramsRow.Jstime,
          Jotime: paramsRow.Jotime,
          Jstate: paramsRow.Jstate,
          Creater: paramsRow.Creater,
          Jaddress: paramsRow.Jaddress,
          Jurl: paramsRow.Jurl,
        }
      } else {
        this.formValidate = {
          Id: 0,
          Jname: '',
          Jstime: s2,
          Jotime: s2,
          Jstate: '',
          Creater: '',
          Jaddress: '',
          Jurl: '',
        }
      }
    },
    handleSubmit(value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.formValidate.Jstime = moment(this.formValidate.Jstime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss');
            this.formValidate.Jotime = moment(this.formValidate.Jotime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss');
            operationJobfaironline(this.formValidate, this.editModalData).then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                if (this.searchVal) {
                  this.getJobfaironlinelist(this.searchVal)
                } else {
                  this.getJobfaironlinelist()
                }
                this.modalMap.modalVisible = false
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
        } else {
          this.$Message.error("缺少必要参数");
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    handlerDelete() {
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要批量删除选中数据嘛？ `)) {
          operationJobfaironline({'id_list': this.tableSelectIdList}, 'delete').then(            res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                this.getJobfaironlinelist(this.searchVal)
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    delData(params) {
      if (confirm(`确定要删除该信息吗？`)) {
        operationJobfaironline(
          {
            'Id': params.row.Id
          },
          'delete'
        ).then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            this.tableData.splice(params.index, 1)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },
    changePage(value) {
      this.pageNum = value
      if (this.searchVal) {
        this.getJobfaironlinelist(this.searchVal)
      } else {
        this.getJobfaironlinelist()
      }
    },
    handlePageSize(value) {
      this.pageSize = value
      this.pageNum = 1
      if (this.searchVal) {
        this.getJobfaironlinelist(this.searchVal)
      } else {
        this.getJobfaironlinelist()
      }
    },
    searchinput() {
      if (this.searchVal) {
        this.getJobfaironlinelist(this.searchVal)
      } else {
        this.getJobfaironlinelist()
      }
    }
  },
  watch: {
    searchVal(val) {
      this.searchVal = val
    }
  },
  mounted() {
    this.getParameterList();
    this.getJobfaironlinelist();
  }
}
</script>
<style lang="less" scoped>
.search-con {
  padding: 10px 0;
  .search {
    &-col {
      display: inline-block;
      width: 200px;
    }
    &-input {
      display: inline-block;
     width: 200px;
      margin-left: 2px;
    }
    &-btn {
      margin-left: 2px;
    }
  }
}
</style>
